module.exports = __webpack_public_path__ + "static/media/avatar.8775fd93.svg";